/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderDirectoryContactType } from './ProviderDirectoryContactType';
import {
    ProviderDirectoryContactTypeFromJSON,
    ProviderDirectoryContactTypeFromJSONTyped,
    ProviderDirectoryContactTypeToJSON,
} from './ProviderDirectoryContactType';

/**
 * 
 * @export
 * @interface ProviderDirectoryContact
 */
export interface ProviderDirectoryContact {
    /**
     * 
     * @type {string}
     * @memberof ProviderDirectoryContact
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderDirectoryContact
     */
    provider_id: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderDirectoryContact
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderDirectoryContact
     */
    position?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderDirectoryContact
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderDirectoryContact
     */
    phone?: string | null;
    /**
     * 
     * @type {ProviderDirectoryContactType}
     * @memberof ProviderDirectoryContact
     */
    contact_type: ProviderDirectoryContactType;
    /**
     * 
     * @type {string}
     * @memberof ProviderDirectoryContact
     */
    user_id?: string | null;
}

/**
 * Check if a given object implements the ProviderDirectoryContact interface.
 */
export function instanceOfProviderDirectoryContact(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "provider_id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "contact_type" in value;

    return isInstance;
}

export function ProviderDirectoryContactFromJSON(json: any): ProviderDirectoryContact {
    return ProviderDirectoryContactFromJSONTyped(json, false);
}

export function ProviderDirectoryContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderDirectoryContact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'provider_id': json['provider_id'],
        'name': json['name'],
        'position': !exists(json, 'position') ? undefined : json['position'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'contact_type': ProviderDirectoryContactTypeFromJSON(json['contact_type']),
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
    };
}

export function ProviderDirectoryContactToJSON(value?: ProviderDirectoryContact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'provider_id': value.provider_id,
        'name': value.name,
        'position': value.position,
        'email': value.email,
        'phone': value.phone,
        'contact_type': ProviderDirectoryContactTypeToJSON(value.contact_type),
        'user_id': value.user_id,
    };
}

